<template>

    <div class="blogcards-element">

        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Recent blog posts</h2>

        <div class="text-center">
            <div class="blocks-action-bar-inline">
                <div class="device-selector--large inline-style">

                    <i class="fas fa-desktop active" data-device="desktopSettings" v-b-tooltip.hover.top title="Desktop" @click="switchDevice"></i>
                    <i class="fas fa-tablet-alt" data-device="tabletSettings" v-b-tooltip.hover.top title="Tablet" @click="switchDevice"></i>
                    <i class="fas fa-mobile-alt" data-device="mobileSettings" v-b-tooltip.hover.top title="Phone" @click="switchDevice"></i>

                </div>
                
            </div>
        </div>

        <div class="preview-box-for-styling" :style="{width : previewBoxWidth}">
            <div class="preview-box-for-styling--inner">
                <div class="bundle-blog-cards-wrapper" :class="settingsFromWeebly.settings.useRoundedEdge ? 'bundle-blog-cards-rounded' : null" :id="'bundle-blog-cards-wrapper'+settingsFromWeebly.settings.blogCardsId">
                    <div class="bundle-blog-cards-link" v-if="settingsFromWeebly.settings.useFiltering">
                        <a href="javascript:void()" class="blog-link active">active category</a>
                        <a href="javascript:void()" class="blog-link">category</a>
                    </div>
                    <div class="bundle-blog-cards" :data-blog-card-url="settingsFromWeebly.settings.blogUrl" :data-blog-card-amount="settingsFromWeebly.settings.blogCardsAmount" :data-paragraph-lines="settingsFromWeebly.settings.showLinesOfText" :data-use-filter-option="settingsFromWeebly.settings.useFiltering ? 'usefilter':'nofilter'">

                        <div class="bundle-blog-block-card" v-for="(card, index) in parseInt(settingsFromWeebly.settings.blogCardsAmount)" :key="index">
                            <div class="bundle-blog-card-image" style="background-image:url(https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg)"></div>
                            <h4 class="bundle-blog-card-title">Your blog title will go here</h4>
                            <div class="bundle-blog-card-text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.</div>
                            <div class="bundle-blog-card-readmore-icon">+</div>
                        </div>

                    </div>
                </div>
            </div><!-- preview-box-for-styling--inner -->
        </div><!-- preview-box-for-styling -->
        
        <div class="preview-box">

            <component :is="style">
                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards {
                    width: calc(100% + 20px);
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-image {
                    height: {{settingsFromWeebly.settings.cardImageHeightDesktop}}px;
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                    border-color: {{settingsFromWeebly.settings.cardBorderColor}};
                    background: {{settingsFromWeebly.settings.cardBg}};
                    width: calc({{100 * 1/settingsFromWeebly.settings.desktopAmountPerRow}}% - 20px );
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-readmore-icon {
                    background: {{settingsFromWeebly.settings.readmoreBg}};
                    color: {{settingsFromWeebly.settings.readmoreColor}};
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card:hover .bundle-blog-card-readmore-icon {
                    background: {{settingsFromWeebly.settings.readmoreBgHover}};
                    color: {{settingsFromWeebly.settings.readmoreColorHover}};
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card .bundle-blog-card-text {
                    color: {{settingsFromWeebly.settings.blogcardTextColor}};
                    font-family: {{settingsFromWeebly.settings.useCustomFontText ? settingsFromWeebly.settings.customFontNameText : settingsFromWeebly.settings.fontFamilyText}};
                    font-style: {{settingsFromWeebly.settings.useCustomFontText ? settingsFromWeebly.settings.customFontStyleText : settingsFromWeebly.settings.fontStyleText}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFontText ? settingsFromWeebly.settings.customFontWeightText : settingsFromWeebly.settings.fontWeightText}};
                    line-height: {{settingsFromWeebly.settings.lineHeightText}};
                    height: {{settingsFromWeebly.settings.showLinesOfText * settingsFromWeebly.settings.lineHeightText}}em;
                    max-height: {{settingsFromWeebly.settings.showLinesOfText * settingsFromWeebly.settings.lineHeightText}}em;
                    font-size: {{settingsFromWeebly.settings.cardTextFontSize}}px;
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card h4 {
                    color: {{settingsFromWeebly.settings.blogcardTitleColor}};
                    font-family: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontName : settingsFromWeebly.settings.fontFamily}};
                    font-style: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontStyle : settingsFromWeebly.settings.fontStyle}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFont ? settingsFromWeebly.settings.customFontWeight : settingsFromWeebly.settings.fontWeight}};
                    font-size: {{settingsFromWeebly.settings.cardTitleFontSize}}px;
                    line-height: {{settingsFromWeebly.settings.lineHeightTitle}};
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-text:before {
                    background: {{settingsFromWeebly.settings.cardBg}};
                    background: linear-gradient(to right, rgba(255,255,255,0) 0%,{{settingsFromWeebly.settings.cardBg}} 60%);
                    height: {{settingsFromWeebly.settings.lineHeightText}}em;
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link {
                    text-align: {{settingsFromWeebly.settings.filterAlignement}};
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link a {
                    border-color: {{settingsFromWeebly.settings.filterItemBorderColor}};
                    color: {{settingsFromWeebly.settings.filterItemColor}};
                    background: {{settingsFromWeebly.settings.filterItemBg}};
                    font-family: {{settingsFromWeebly.settings.useCustomFontFilter ? settingsFromWeebly.settings.customFontNameText : settingsFromWeebly.settings.fontFamilyFilter}};
                    font-style: {{settingsFromWeebly.settings.useCustomFontFilter ? settingsFromWeebly.settings.customFontStyleFilter : settingsFromWeebly.settings.fontStyleFilter}};
                    font-weight: {{settingsFromWeebly.settings.useCustomFontFilter ? settingsFromWeebly.settings.customFontWeightFilter : settingsFromWeebly.settings.fontWeightFilter}};
                    font-size: {{settingsFromWeebly.settings.cardFilterFontSize}}px;
                }

                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link a:hover,
                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-cards-link a.active {
                    border-color: {{settingsFromWeebly.settings.filterItemBorderColorHover}};
                    color: {{settingsFromWeebly.settings.filterItemColorHover}};
                    background: {{settingsFromWeebly.settings.filterItemBgHover}};
                }

                @media(max-width:768px){
                    #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                        width: calc({{100 * 1/settingsFromWeebly.settings.tabletAmountPerRow}}% - 20px );
                    }
                    #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-image {
                        height: {{settingsFromWeebly.settings.cardImageHeightTablet}}px;
                    }
                }

                @media(max-width:576px){
                    #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                        width: calc({{100 * 1/settingsFromWeebly.settings.phoneAmountPerRow}}% - 20px );
                    }
                    #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-image {
                        height: {{settingsFromWeebly.settings.cardImageHeightPhone}}px;
                    }
                }

            </component>

            <component :is="style" v-if="deviceStylesSetttings.tabletStyles">
                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                    width: calc({{100 * 1/settingsFromWeebly.settings.tabletAmountPerRow}}% - 20px );
                }
                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-image {
                    height: {{settingsFromWeebly.settings.cardImageHeightTablet}}px;
                }
            </component>

            <component :is="style" v-if="deviceStylesSetttings.mobileStyles">
                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-block-card {
                    width: calc({{100 * 1/settingsFromWeebly.settings.phoneAmountPerRow}}% - 20px );
                }
                #bundle-blog-cards-wrapper{{settingsFromWeebly.settings.blogCardsId}} .bundle-blog-card-image {
                    height: {{settingsFromWeebly.settings.cardImageHeightPhone}}px;
                }
            </component>

            <div class="bundle-blog-cards-wrapper" :class="settingsFromWeebly.settings.useRoundedEdge ? 'bundle-blog-cards-rounded' : null" :id="'bundle-blog-cards-wrapper'+settingsFromWeebly.settings.blogCardsId">
                <div class="bundle-blog-cards-link"></div>
                <div class="bundle-blog-cards" :data-blog-card-url="settingsFromWeebly.settings.blogUrl" :data-blog-card-amount="settingsFromWeebly.settings.blogCardsAmount" :data-paragraph-lines="settingsFromWeebly.settings.showLinesOfText" :data-use-filter-option="settingsFromWeebly.settings.useFiltering ? 'usefilter':'nofilter'">
                </div>
                <div class="loading-bundle-blog-cards"><i class="fas fa-circle-notch fa-spin"></i><br><br>Loading...</div>
            </div>

        </div>

    </div>

</template>

<script>

export default {

    name: 'Blogcards',

    data () {

        return {
            style: 'style'
        }
    },

    components: {

    },

    methods: {
        switchDevice(event) {

            // remove active class from possible elements
            const icons = document.querySelectorAll('.device-selector--large i');
            icons.forEach(icon => {
                console.log(icon)
                icon.classList.remove('active')
            })
            
            // add active class to current
            event.target.classList.add('active');

            console.log(event.target.dataset.device)

            // set active settings to true
            this[event.target.dataset.device] = true

            if(event.target.dataset.device === 'tabletSettings') {
                this.$store.state.previewBoxWidth = '768px'
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.tabletStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else if (event.target.dataset.device === 'mobileSettings') {
                this.$store.state.previewBoxWidth = '576px'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = true
                this.$store.state.deviceStyles.desktopStyles = false
            } else {
                this.$store.state.previewBoxWidth = '100%'
                this.$store.state.deviceStyles.tabletStyles = false
                this.$store.state.deviceStyles.mobileStyles = false
                this.$store.state.deviceStyles.desktopStyles = true
            }

        }   
    },

    computed: {

        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        }

    },
    
    mounted() {
        console.log('from Anchor', this.$store.state.weeblySettings)
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '../../less/colors.less';
.preview-box .only-weebly-editor {
    display: block;
}
.preview-box-for-styling {
    padding: 75px 15px;
    background: #fff;
    border-radius: 0.25rem;
    margin: 0 auto;
    -webkit-transition: width 0.15s ease-out;
    transition: width 0.15s ease-out;
    margin-bottom: 15px;

    .preview-box-for-styling--inner {
        max-width: 985px;
        margin: 0 auto;
    }

    .bundle-blog-cards {
        opacity: 1;
    }
    .bundle-blog-cards-link {
        display: block;

    }
}
.blogcards-element {
    .preview-box {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/Blogcards.vue